// utils/googleAdsConversion.ts — Google Ads (AW-) event snippet → fire programatik.
//
// Kenapa: snippet konversi Google Ads (`gtag('event','conversion',{send_to:'AW-xxx/label'})`)
// TIDAK boleh di-inject saat halaman dibuka kecuali untuk event yang memang terjadi
// saat itu (VC/Lead). ATC & IC harus di-fire persis saat interaksi (nama+WA valid /
// klik kirim) — kalau di-inject, ikut ke-fire di page load = konversi palsu.
//
// Satu sumber kebenaran: baca snippet dari form.customScripts.platforms.google,
// ekstrak `send_to`, lalu panggil gtag pada momen yang benar.

const SEND_TO_RE = /send_to['"]?\s*[:=]\s*['"]([^'"]+)['"]/i;

export type GoogleAdsEvent = 'vc' | 'atc' | 'ic' | 'lead';

/** Ambil nilai `send_to` (mis. `AW-18230961984/muacCKu-1_scEMDOmfVD`) dari snippet. */
export function extractSendTo(snippet?: string): string | null {
  if (!snippet) return null;
  const m = snippet.match(SEND_TO_RE);
  return m?.[1]?.trim() || null;
}

/** Snippet Google Ads utk satu event (mode baru). */
export function googleAdsSnippet(form: any, event: GoogleAdsEvent): string | undefined {
  return form?.customScripts?.platforms?.google?.[event];
}

/**
 * Fire konversi Google Ads utk 1 event. Return false kalau tidak ada snippet /
 * label / gtag belum siap (aman, tidak pernah throw).
 */
export function fireGoogleAdsConversion(
  form: any,
  event: GoogleAdsEvent,
  opts: { value?: number; currency?: string; dedupeKey?: string } = {},
): boolean {
  try {
    const sendTo = extractSendTo(googleAdsSnippet(form, event));
    if (!sendTo) return false;
    const gtag = (window as any).gtag;
    if (typeof gtag !== 'function') return false;

    if (opts.dedupeKey) {
      const k = `ga_conv_${event}_${opts.dedupeKey}`;
      try {
        if (sessionStorage.getItem(k)) return false;
        sessionStorage.setItem(k, '1');
      } catch { /* storage ditolak (iframe sandbox): lanjut tanpa dedup */ }
    }

    gtag('event', 'conversion', {
      send_to: sendTo,
      currency: opts.currency || 'IDR',
      ...(opts.value !== undefined ? { value: opts.value } : {}),
    });
    return true;
  } catch { return false; }
}
